import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FirestoreService } from 'src/app/service/firestore.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {

  verficationForm = new FormGroup({
    verify: new FormControl()
  });
  constructor(public fservice: FirestoreService) { }

  ngOnInit(): void {
  }

  sendVerificationEmail() {
    this.fservice.sendVerificationEmail();
  }

}
